/*
 * Back in Stock Klaviyo sul catalogo "API: Default" (stock della sola location "1 - Shop online").
 * Sostituisce lo snippet Klaviyo classico (onsite.js + klaviyo.enable("backinstock")).
 * Il pulsante è renderizzato da snippets/klaviyo-bis-api.liquid; qui c'è il modale condiviso.
 */
(function () {
  if (window.klaviyoBisApi) return;
  window.klaviyoBisApi = true;

  var COMPANY_ID = 'T83W5s';
  var REVISION = '2026-10-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var style = document.createElement('style');
  style.textContent =
    '.kbis-dialog, .kbis-dialog * { box-sizing: border-box; }' +
    // Il tema dà ai <dialog> uno stile da drawer a tutta altezza: qui lo riportiamo a un modale centrato.
    'dialog.kbis-dialog { position: fixed; inset: 0; margin: auto; width: min(440px, calc(100% - 32px)); height: fit-content; max-height: calc(100% - 32px); overflow: auto; padding: 40px 24px 24px; border: 0; background: #fff; color: #100f12; }' +
    '.kbis-dialog::backdrop { background: rgba(0, 0, 0, .5); }' +
    '.kbis-dialog__form { display: flex; flex-direction: column; gap: 12px; margin: 0; }' +
    '.kbis-dialog__close { position: absolute; top: 8px; right: 12px; padding: 4px; background: none; border: 0; font-size: 28px; line-height: 1; color: #100f12; cursor: pointer; }' +
    '.kbis-dialog__title { margin: 0; font-size: 1.2em; }' +
    '.kbis-dialog__text, .kbis-dialog__msg { margin: 0; }' +
    '.kbis-dialog__input { width: 100%; padding: 12px; border: 1px solid #100f12; font: inherit; }' +
    '.kbis-dialog__msg { min-height: 1.4em; }' +
    '.kbis-dialog__msg--ok { padding: 8px 12px; background: #d3efcd; color: #1b9500; }' +
    '.kbis-dialog__msg--error { padding: 8px 12px; background: #fcd6d7; color: #c72e2f; }' +
    '.kbis-dialog__msg:empty { display: none; }';
  document.head.appendChild(style);

  var dialog = document.createElement('dialog');
  dialog.className = 'kbis-dialog';
  dialog.setAttribute('aria-labelledby', 'kbis-dialog-title');
  dialog.innerHTML =
    '<button type="button" class="kbis-dialog__close" data-kbis-close>&times;</button>' +
    '<form class="kbis-dialog__form" novalidate>' +
    '<h2 class="kbis-dialog__title" id="kbis-dialog-title"></h2>' +
    '<p class="kbis-dialog__text"></p>' +
    '<label for="kbis-dialog-email">Email</label>' +
    '<input class="kbis-dialog__input" id="kbis-dialog-email" type="email" name="email" autocomplete="email" required>' +
    '<button type="submit" class="btn btn--primary btn--solid"></button>' +
    '<p class="kbis-dialog__msg" role="status" aria-live="polite"></p>' +
    '</form>';

  var form = dialog.querySelector('form');
  var title = dialog.querySelector('.kbis-dialog__title');
  var text = dialog.querySelector('.kbis-dialog__text');
  var input = dialog.querySelector('input');
  var submit = dialog.querySelector('[type="submit"]');
  var msg = dialog.querySelector('.kbis-dialog__msg');
  var close = dialog.querySelector('[data-kbis-close]');
  var current = null;

  function mount() {
    if (!dialog.isConnected) document.body.appendChild(dialog);
  }

  function setMessage(value, kind) {
    msg.textContent = value || '';
    msg.className = 'kbis-dialog__msg' + (kind ? ' kbis-dialog__msg--' + kind : '');
  }

  function variantId(trigger) {
    // Variante selezionata nel form prodotto; altrimenti quella renderizzata dal server.
    var productForm = trigger.closest('form');
    var field = productForm && productForm.querySelector('[name="id"]');
    return String((field && field.value) || trigger.dataset.variantId);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-kbis-open]');
    if (!trigger) return;
    e.preventDefault();
    mount();
    current = {
      variantId: variantId(trigger),
      strings: JSON.parse(trigger.dataset.kbisStrings)
    };
    title.textContent = trigger.dataset.productTitle;
    text.textContent = current.strings.body;
    submit.textContent = current.strings.submit;
    close.setAttribute('aria-label', current.strings.close);
    submit.disabled = false;
    setMessage('');
    dialog.showModal();
    input.focus();
  });

  close.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = input.value.trim();
    if (!EMAIL_RE.test(email)) {
      setMessage(current.strings.invalid, 'error');
      input.focus();
      return;
    }

    submit.disabled = true;
    setMessage('');
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$custom:::$default:::' + current.variantId } }
          }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      setMessage(current.strings.success, 'ok');
      input.value = '';
    }).catch(function () {
      submit.disabled = false;
      setMessage(current.strings.error, 'error');
    });
  });
})();
